import { render, staticRenderFns } from "./BackNavigationBar.vue?vue&type=template&id=bd260942&scoped=true"
import script from "./BackNavigationBar.vue?vue&type=script&lang=js"
export * from "./BackNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./BackNavigationBar.vue?vue&type=style&index=0&id=bd260942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd260942",
  null
  
)

export default component.exports